import { Node, mergeAttributes } from '@tiptap/core';
export const Figure = Node.create({
    name: 'figuur',
    group: 'block',
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            hash: { default: null },
            bestandsnaam: { default: null },
            grootteBytes: { default: null },
        };
    },
    parseHTML() {
        return [{ tag: 'figure[data-hash]' }];
    },
    renderHTML({ HTMLAttributes }) {
        // Geen `img`: er is in M2 geen adres om naartoe te wijzen, en een gebroken
        // afbeelding is voor een invuller een storing. Het kader met de naam zegt wat er
        // hangt; de weergave met de echte bytes komt met de opslag in M3.
        return [
            'figure',
            mergeAttributes(HTMLAttributes, { class: 'ef-figuur', 'data-hash': HTMLAttributes['hash'] }),
            ['figcaption', {}, String(HTMLAttributes['bestandsnaam'] ?? '')],
        ];
    },
});
//# sourceMappingURL=figure.js.map